<template>
  <div class="detailBox">
    <div class="swiperBox" :style="SetHeight()">
      <swiper class="swiper" :options="swiperOptionTop">
        <swiper-slide class="slide" v-for="(item, index) in imgList" :key="index">
          <img :src="item" class="like_img">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="priceInfo" v-if="list.Status==1">
      <div class="bigRadius"></div>
      <div class="priceBox">
        <span class="priceTxet">{{list.Status==1&&list.ByWay==2?'Current Bid':'Price'}}</span>
        <div class="priceDetail"><em>$</em>{{list.USD_Price}}<span v-if="list.Status==1&&list.ByWay==2" class="priceBid">{{list.AuctionCount}}</span></div>
      </div>
      <div class="timeInfo">
        <div class="">{{list.EffectiveTime |setTime}}</div>
        <div class="timeDown">
          <span>{{CountDown(list.EffectiveTime)[0]}}</span>
          <span>{{CountDown(list.EffectiveTime)[1]}}</span>
          <span>{{CountDown(list.EffectiveTime)[2]}}</span>
          <span>{{CountDown(list.EffectiveTime)[3]}}</span>
        </div>
      </div>
    </div>
    <div class="detailInfo">
      <div class="d_info">
        <div class="priceEndlist" v-if="list.Status==-2||list.Status==-1">
          <div class="priceDetail"><em>$</em>{{list.USD_Price}}<span v-if="list.ByWay==2" class="priceBid">{{list.AuctionCount}}</span></div>
          <div class="endlist" :class="list.Status==-2?'soldout':''"></div>
        </div>
        <p class="title">{{list.Title}}</p>
        <p class="title" v-if="list.Status==-2||list.Status==-1">#{{list.Code}}</p>
      </div>
      <div class="d_info" v-if="list.ByWay==2">
        <div class="infoTitle">
          {{$t('base.bidHistory')}}
          <span>{{list.AuctionCount}}</span>
        </div>
        <ul class="auctionList" v-if="list.Auctions.length>0">
          <li v-for="(item,index) in list.Auctions" :key="index" v-if="index<3">
            <div>
              $ {{item.USD_Price}}
              <div>{{item.CreateUserName}} | ({{item.BuyFavorableCount}})</div>
            </div>
            <div>
              {{CountDown2(item.CreateDate)[0]>'00'?CountDown2(item.CreateDate)[0]+' days':''}}
              {{CountDown2(item.CreateDate)[1]>'00'?CountDown2(item.CreateDate)[1]+' hours':''}}
              {{CountDown2(item.CreateDate)[2]>'00'?CountDown2(item.CreateDate)[2]+' mins':''}}
              {{CountDown2(item.CreateDate)[0]>'00'?'':CountDown2(item.CreateDate)[3]+' secs'}}
              {{$t('base.ago')}}
            </div>
          </li>
        </ul>
      </div>
      <div class="d_info">
        <div class="howToBid">
          <span>{{$t('symbol.bid')}}</span>
          <span>{{ $t('base.rulesOfBidding') }}</span>
        </div>
      </div>
      <div class="d_info" v-if="list.DomesticCustom.length>0">
        <ul class="detailList">
          <li>
            <div>{{$t('base.shipping')}}</div>
            <div>$ {{list.DomesticCustom[0].USD_Price}}</div>
          </li>
          <li>
            <div>{{ $t('base.shipsFrom') }}</div>
            <div>{{list.DomesticCustom[0].AreaName}}</div>
          </li>
        </ul>
      </div>
      <div class="d_info">
        <div class="infoTitle">
          {{$t('base.itemDetails')}}
          <span></span>
        </div>
        <ul class="detailList">
          <li v-for="(item,index) in list.Properties" :key="index">
            <div>{{item.PropertyEnName}}</div>
            <div>{{item.PropertyValue}}</div>
          </li>
        </ul>
      </div>
      <div class="d_info">
        <div class="infoTitle">
          {{$t('alert.sellerDescription')}}
          <span></span>
        </div>
        <p class="listDetail" v-html="list.Detail!=null?list.Detail:''"></p>
      </div>
      <div class="d_info">
        <div class="sellerInfo">
          <img :src="sellerInfo.StoreLogo">
          <div>
            {{sellerInfo.StoreName}}
            <span>{{sellerInfo|setFeedback}} {{$t('base.PositiveFeedback')}}</span>
          </div>
        </div>
        <div class="sellerCommodities">
          <div class="CommoditiesList" v-for="(item,index) in sellerInfo.Commodities" :key="index">
            <img :src="item.TitImg">
          </div>
        </div>
      </div>
    </div>
    <div class="fixed">
      <div class="btn">{{$t('base.open')}}</div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { shareTime, getInfo, getTime, setUTC, priceExchange, GetWindowsWidth } from "@/api/public";
export default {
  name: 'index',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      cid: '',
      list: null,
      ByWay: '',
      imgList: [],
      Detail: '',
      HighestPrice: '',
      sellerInfo: '',
      swiperOptionTop: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
      },
      timer: "",
      nowData: new Date().getTime(),
    }
  },
  filters: {
    setFeedback(val) {
      let data = ((val.BuyFavorableCount / (val.BuyFavorableCount + val.BuyNegativeCount)) * 100)
      if (val.BuyFavorableCount + val.BuyNegativeCount > 0) {
        if (data != 100) {
          data = data.toFixed(2)
        }
      } else {
        data = 100
      }
      return data + ' %'
    },
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    }
  },
  mounted() {},
  created() {
    this.cid = this.$route.params.id
    this.GetDetail();
    this.cardTimer();
  },
  methods: {
//     <meta property="og:title" content="天猫">
// <meta property="og:type" content="website">
// <meta property="og:url" content=" https://www.tmall.com/">
// <meta property="og:image" content=" https://img.alicdn.com/tfs/TB1MaLKRXXXXXaWXFXXXXXXXXXX-480-260.png">

    //设置头图高度
    SetHeight() {
      let getWidth = GetWindowsWidth()
      return 'height:' + getWidth + 'px'
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      let time = shareTime(val, newval).split(',')
      return time
    },
    CountDown2(itemEnd) {
      let val = setUTC(itemEnd, -8, 'cn')
      let newval = setUTC(this.nowData, -8)
      let time = shareTime(newval, val).split(',')
      return time
    },
    GetDetail() {
      let that = this;
      let data = { 'memberid': '', 'CommodityID': this.cid, 'lag': 'en' }
      that.$get(that.$interface.DetailCommodity, data).then(res => {
        if (res.result != 0) {
          let data = res.data
          that.ByWay = data.ByWay
          document.title = data.Title;
          data.HighestPrice = priceExchange(data.HighestPrice, 'USD')
          data.Detail = decodeURIComponent(data.Detail)
          that.list = data;
          that.imgList = data.images.split(',')
          that.GetStoresList(data.SellUserID)
        } else {
          that.list = null;
          that.errorMsg = res.msg
        }
      })
    },
    //获取商家信息
    GetStoresList(val) {
      let that = this
      let data = { 'Id': val, 'MemberId': '' }
      this.$get(this.$interface.GetStoreDetail, data).then(res => {
        if (res.result != 0) {
          console.log(that.sellerInfo)
          that.sellerInfo = res.data
        }
      })
    },
  }
}

</script>
<style scoped>
.detailBox {
  height: 100%;
  background-color: #f7f7f7;
}

.swiperBox {
  width: 100%;
  position: relative;
  background-color: #fff;
}

.swiperBox .swiper,
.swiperBox .slide,
.swiperBox .slide .like_img {
  width: 100%;
  height: 100%;
}

.swiperBox .slide .like_img {
  object-fit: contain;
}

.swiper-pagination {
  background: rgba(0, 0, 0, .4);
  width: auto;
  right: 12px;
  bottom: 12px;
  left: auto;
  font-size: 14px;
  padding: 2px 6px 0px;
  color: #fff;
  border-radius: 10px;
}

.priceInfo {
  width: 100%;
  height: 72px;
  background: #5F6DAE;
  display: flex;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}

.timeInfo {
  position: relative;
  z-index: 1;
  padding: 12px;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
}

.timeDown {
  text-align: right;
}

.timeDown span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #fff;
  text-align: center;
  line-height: 20px;
  margin-left: 16px;
  position: relative;
  color: #333;
}

.timeDown span:before {
  content: ':';
  position: absolute;
  top: 0;
  left: -12px;
  color: #fff;
  font-weight: bold;
}

.timeDown span:nth-child(2):before {
  content: 'd';
  font-weight: normal;
  left: -14px;
}

.timeDown span:first-child:before {
  display: none;
}

.priceBox {
  padding: 12px;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
}

.priceTxet {
  font-size: 12px;
}

.priceDetail {
  font-size: 24px;
  font-weight: 700;
  align-items: baseline;
  line-height: 6px;
}

.priceDetail em,
.priceDetail span {
  font-size: 12px;
  font-weight: normal;
  margin-right: 2px;
}

.priceDetail .priceBid {
  padding-left: 20px;
  position: relative;
  top: -2px;
  margin-left: 8px;
  margin-right: 0;
}

.priceDetail .priceBid:before {
  content: '';
  width: 16px;
  height: 16px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: url(../../../static/images/app/bid1.svg) no-repeat;
}

.d_info .priceDetail {
  color: #a0a0a0;
}

.priceEndlist {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d_info .priceDetail .priceBid:before {
  background-image: url(../../../static/images/app/bid2.svg);
}

.d_info .endlist {
  width: 56px;
  height: 40px;
  background: url(../../../static/images/app/endlist.svg) no-repeat;
}

.d_info .soldout {
  background-image: url(../../../static/images/app/soldout.svg);
}

.bigRadius {
  z-index: 0;
  position: absolute;
  right: -145px;
  top: -23px;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background: linear-gradient(90deg, #9BABF5 -52.3%, #6170B6 100%);
}

.detailInfo {
  overflow: hidden;
  padding: 0 12px;
  background-color: #f7f7f7;
  padding-bottom: 45px;
}

.d_info {
  margin: 12px 0;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 8px;
}

.title {
  font-size: 18px;
  line-height: 1.2;
}

.infoTitle {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  margin-bottom: 8px;
}

.infoTitle span {
  color: #a0a0a0;
  font-size: 14px;
  padding-right: 12px;
  position: relative;
}

.infoTitle span::after {
  content: '';
  width: 5px;
  height: 5px;
  top: 4px;
  right: 2px;
  border-right: 1px solid #a0a0a0;
  border-bottom: 1px solid #a0a0a0;
  transform: rotate(-45deg);
  position: absolute;
}

.auctionList li {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  margin-bottom: 8px;
}

.detailList {
  overflow: hidden;
}

.detailList li {
  display: flex;
  padding: 4px 0;
}

.detailList li>div {}

.detailList li>div:first-child {
  width: 30%;
  flex-shrink: 0;
  color: #a0a0a0;
  padding-right: 16px;
  word-break: break-all;
}

.detailList li>div:last-child {
  flex: 1;
}

.listDetail {
  font-size: 12px;
  line-height: 1.2;
}

.howToBid {
  display: flex;
  justify-content: space-between;
}

.howToBid span {
  color: #5F6DAE;
  text-align: center;
  padding: 8px 0;
  border-radius: 4px;
  background-color: #f7f7f7;
  width: 47%;
  display: inline-block;
}

.sellerCommodities {
  width: auto;
  overflow-x: auto;
  white-space: nowrap;
}

.CommoditiesList {
  width: 104px;
  height: 104px;
  border-radius: 4px;
  overflow: hidden;
  display: inline-block;
  margin-right: 4px;
}

.CommoditiesList:last-child {
  margin-right: 0;
}

.CommoditiesList img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sellerInfo {
  display: flex;
  margin-bottom: 12px;
}

.sellerInfo img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 8px;
}

.sellerInfo>div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sellerInfo>div span {
  font-size: 12px;
  color: #a0a0a0;
}

.fixed {
  position: fixed;
  width: 100%;
  padding: 5px 8px;
  left: 0;
  bottom: 0;
  background-color: #fff;
}

.fixed .btn {
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background-color: #5F6DAE;
  border-radius: 6px;
}

</style>



// WEBPACK FOOTER //
// src/pages/shared/sharecard.vue